export const SET_USER_DATA = 'SET_USER_DATA'

/** PROFILES */
export const SET_PROFILES = 'SET_PROFILES'
export const ADD_PROFILE = 'ADD_PROFILE'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'

/** SOCIAL MEDIA */
export const SET_SOCIAL_MEDIA = 'SET_SOCIAL_MEDIA'

export const EXPLOR_PEOPLE = 'EXPLOR_PEOPLE'